var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suggestion-list",style:({height: _vm.height})},_vm._l((_vm.options),function(option){return _c('div',{on:{"click":function($event){return _vm.$emit('change',option)}}},[_vm._v(_vm._s(option)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }